import React, { useState } from "react";

// Small square school avatar: renders the school's logo when one is set,
// otherwise a monogram (first letter) in a soft blue tile. Also falls back to
// the monogram if the image fails to load (stale/broken logoUrl).
const SchoolLogo = ({ name, logoUrl, size = 28 }) => {
  const [errored, setErrored] = useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";

  if (logoUrl && !errored) {
    return (
      <img
        src={logoUrl}
        alt={`${name || "School"} logo`}
        onError={() => setErrored(true)}
        className="rounded-md object-contain bg-white border border-gray-200 flex-shrink-0"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      aria-hidden="true"
      className="rounded-md bg-blue-50 text-blue-600 font-semibold flex items-center justify-center flex-shrink-0"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.45) }}
    >
      {initial}
    </span>
  );
};

export default SchoolLogo;
